import type {
  GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200,
  GetApiV1ThreeLetterCodePartnerAdminsGroups200,
  GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200,
} from '@fukuri-admins/apis/client/gen/model';
import { getFeatureFlagLabel } from '~/utils/clientFeatureFlagUtils';
import { LegacyCreateClientFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof LegacyCreateClientFormPresentation>;

type IConvertToPresentationProps = (args: {
  /** グループ一覧 */
  groups: GetApiV1ThreeLetterCodePartnerAdminsGroups200;
  /** クライアントの機能フラグ */
  clientFeatureFlags: GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200;
  /** パートナーの機能フラグ */
  partnerFeatureFlags: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200;
}) => {
  groupOptions: PresentationProps['groupOptions'];
  featureFlags: PresentationProps['featureFlags'];
};

/**
 * hooksの状態をプレゼンテーション用のpropsに変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({
  groups,
  clientFeatureFlags,
  partnerFeatureFlags,
}) => ({
  groupOptions: groups.groups.map(({ id, name, code }) => ({ id: String(id), name, code })),
  featureFlags: clientFeatureFlags.client_feature_flags.map(({ feature_key }) => ({
    value: String(feature_key),
    label: getFeatureFlagLabel(feature_key),
    disabled: !partnerFeatureFlags.partner_feature_flags.some(
      pf => pf.feature_key === feature_key && pf.enabled
    ),
  })),
});
